export { default } from './ModalFade';
